export const getKeyValueList = ({ state }) => state.keyValue.keyValueList;
export const getKeyValuePageSize = ({ state }) => state.keyValue.pageSize;
export const getKeyValueListcurrentPage = ({ state }) => state.keyValue.currentPage;
export const getKeyValueListRowCount = ({ state }) => state.keyValue.rowCount;
export const getKeyValueStatus = ({ state }) => state.keyValue.keyValueStatus;
